import {inject, Injectable, signal} from '@angular/core';
import {TicketTag} from '../models/ticket-tag.model';
import {ToastMessageEffectService} from '../../../core/services/toast-message-effect.service';

@Injectable({ providedIn: 'root' })
export class TagsStore {
	private toastEffect = inject(ToastMessageEffectService);

	private readonly _tags = signal<TicketTag[]>([]);
	private readonly _loading = signal(false);
	private readonly _error = signal<string | null>(null);

	readonly tags = this._tags.asReadonly();
	readonly loading = this._loading.asReadonly();
	readonly error = this._error.asReadonly();

	constructor() {
		this.toastEffect.registerErrorSignal(this.error);
	}

	setTags(tags: TicketTag[]) {
		this._tags.set(tags);
	}

	setLoading(val: boolean) {
		this._loading.set(val);
	}

	setError(err: string | null) {
		this._error.set(err);
	}
}
